export function Breadcrumbs({ items }) {
  return (
    <nav className="flex py-4 px-4 sm:px-6 lg:px-8" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-4">
        <li>
          <a href="/" className="text-gray-400 hover:text-gray-500">
            Inicio
          </a>
        </li>
        {items.map((item, index) => (
          <li key={index}>
            <div className="flex items-center">
              <svg
                className="flex-shrink-0 h-5 w-5 text-gray-300"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
              </svg>
              <a
                href={item.href}
                className={`ml-4 ${
                  index === items.length - 1
                    ? 'text-gray-800 font-medium'
                    : 'text-gray-400 hover:text-gray-500'
                }`}
                aria-current={index === items.length - 1 ? 'page' : undefined}
              >
                {item.name}
              </a>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
} 